import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import i18n from '../i18n';
import { compose } from 'redux';
import { connect } from 'react-redux';
import SchedulesActions from '../redux/SchedulesRedux';
import { withStyles } from '@material-ui/styles';
import withWidth from '@material-ui/core/withWidth';
import clsx from 'clsx';
import { Colors, StyledComponents, Metrics } from '../themes';
import cloneDeep from 'lodash/cloneDeep';
import AlertDialog from '../components/common/AlertDialog';
import SnackbarNotification from '../components/common/SnackbarNotification';
import Header from '../components/header/Header';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '../components/common/Table';
import SchedulesDetails from '../components/schedulesElements/SchedulesDetails';
import { days } from '../config/AppConfig';
import { convertTimeToDate, generateId } from '../lib/Utils';

const { MainContentContainer } = StyledComponents;

const styles = (theme) => ({
  gridContainer: {
    [theme.breakpoints.up('xl')]: {
      maxWidth: Metrics.contentGridMaxWidthXl.general,
    },
  },
  paper: {
    textAlign: 'center',
    background: Colors.hoverGrey,
    color: Colors.white,
  },
  listWidget: {},
  detailsWidget: {
    maxWidth: 975,
  },
});

class Schedules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // snackbar
      isSnackbarNotificationOpen: false,
      snackbarVariant: 'warning',
      snackbarMessage: '',
      // alert confirm dialog
      isAlertDialogOpen: false,
      alertTitle: '',
      alertContentText: '',
      alertConfirmAction: null,
      isSaveAlert: false,
      // schedules page params
      schedulesItemsPerPage: 10,
      schedulesPageNumber: 0,
      schedulesSearchValue: null,
      schedulesSortDirection: 'ASC',
      // schedules details
      hideDetails: true,
      isNewSchedule: false,
      scheduleNameId: null,
      name: '',
      description: '',
      weeklyData: [],
      yearlyData: [],
      checkedExceptions: [],
      // validation
      isUntouched: true,
    };
  }

  componentDidMount() {
    if (this.props.customerId) {
      this.sendGetSchedulesRequest();
    }
  }

  componentWillUnmount() {
    this.props.resetSchedules();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customerId !== this.props.customerId) {
      this.props.resetSchedules();
      this.resetScheduleFormFields();
      if (this.props.customerId) {
        this.sendGetSchedulesRequest();
      }
    }
    if (prevProps.schedulesIsLoading && !this.props.schedulesIsLoading) {
      if (this.props.schedulesSuccessMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.schedulesSuccessMessage,
        });
      }
      if (this.props.schedulesErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.schedulesErrorMessage,
        });
      }
      if (prevProps.createdSchedule !== this.props.createdSchedule) {
        console.log('this.props.createdSchedule:', this.props.createdSchedule);
        this.selectSchedule(this.props.createdSchedule);
      }
    }
  }

  //common methods

  handleChangeFormValues = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  // schedules list table methods

  sendGetSchedulesRequest() {
    const pageParams = {
      items: this.state.schedulesItemsPerPage,
      page: this.state.schedulesPageNumber,
      value: this.state.schedulesSearchValue,
      sort: this.state.schedulesSortDirection,
    };
    this.props.getSchedules(this.props.customerId, pageParams);
  }

  changeSchedulesItemsPerPage = (schedulesItemsPerPage) => {
    this.setState({ schedulesItemsPerPage, schedulesPageNumber: 0 }, () => this.sendGetSchedulesRequest());
  };

  changeSchedulesPage = (schedulesPageNumber) => {
    this.setState({ schedulesPageNumber }, () => this.sendGetSchedulesRequest());
  };

  handleSearchSchedule = (schedulesSearchValue) => {
    this.setState({ schedulesSearchValue, schedulesPageNumber: 0 }, () => this.sendGetSchedulesRequest());
    this.resetScheduleFormFields();
  };

  handleSortSchedule = (schedulesSortBy, schedulesSortDirection) => {
    this.setState({ schedulesSortDirection, schedulesPageNumber: 0 }, () => this.sendGetSchedulesRequest());
    this.resetScheduleFormFields();
  };

  handleSearchScheduleKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchSchedule(value);
    }
  };

  handleScheduleDetailsFormKeyPress = () => {
    console.log('handleScheduleDetailsFormKeyPress not implemented');
  };

  selectSchedule = ({ scheduleNameId, name, description, schedules, scheduleExceptions }) => {
    const weeklyData = schedules.map((day) => {
      const dayNameObj = days.find((dayObj) => dayObj.id === day.weekDay);
      const dayName = i18n.t(`Global_${dayNameObj.name}`);
      let dayData = day;
      if (!dayData) {
        dayData = { weekDay: day.id };
      }
      return { rowId: generateId(), dayName, ...dayData };
    });

    //Is this correct. Needs check
    const convertToNull = weeklyData.map((schedule) => {
      if (schedule.minTime === '00:00:00' && schedule.maxTime === '00:00:00') {
        return { ...schedule, minTime: null, maxTime: null };
      }
      return schedule;
    });
    const yearlyData = scheduleExceptions
      ? scheduleExceptions.map((schedule) => ({ ...schedule, rowId: generateId() }))
      : [];
    this.setState({
      hideDetails: false,
      isNewSchedule: false,
      isUntouched: true,
      scheduleNameId,
      name,
      description,
      weeklyData: convertToNull,
      yearlyData,
    });
  };

  // schedule details form methods

  resetScheduleFormFields = () => {
    const emptyWeek = days.map((day) => {
      const dayName = i18n.t(`Global_${day.name}`);
      return {
        rowId: generateId(),
        weekDay: day.id,
        dayName,
        minTime: '00:00:00',
        maxTime: '23:59:00',
        mandatory: true,
      };
    });
    this.setState({
      scheduleNameId: null,
      name: '',
      description: '',
      isUntouched: true,
      weeklyData: emptyWeek,
      yearlyData: [],
      checkedExceptions: [],
    });
  };
  handleAddSchedule = () => {
    this.resetScheduleFormFields();
    this.setState({ hideDetails: false, schedulesSearchValue: null, isNewSchedule: true });
  };

  handleSaveSchedule = () => {
    const { scheduleNameId, name, description, weeklyData, yearlyData } = this.state;
    const schedules = weeklyData.map((schedule) => ({
      ...(schedule.scheduleId && { scheduleId: schedule.scheduleId }),
      weekDay: schedule.weekDay,
      minTime: convertTimeToDate(schedule.minTime),
      maxTime: convertTimeToDate(schedule.maxTime),
    }));
    const scheduleExceptions = yearlyData.map((schedule) => ({
      ...(schedule.scheduleExceptionId && { scheduleExceptionId: schedule.scheduleExceptionId }),
      exceptionDate: schedule.exceptionDate.replace('Z', ''),
      startTime: convertTimeToDate(schedule.startTime),
      endTime: convertTimeToDate(schedule.endTime),
    }));
    const scheduleInfos = {
      name,
      description,
      schedules,
      scheduleExceptions,
      customerId: this.props.customerId,
    };
    const editScheduleInfos = {
      ...scheduleInfos,
      scheduleNameId,
    };
    const pageParams = {
      items: this.state.schedulesItemsPerPage,
      page: this.state.schedulesPageNumber,
      value: this.state.schedulesSearchValue,
      sort: this.state.schedulesSortDirection,
    };

    this.state.isNewSchedule
      ? this.props.createSchedule(scheduleInfos, this.props.customerId, pageParams)
      : this.props.editSchedule(editScheduleInfos, this.props.customerId, pageParams);
  };

  openDeleteScheduleAlert = () => {
    const scheduleName = this.state.name;
    this.setState({
      isAlertDialogOpen: true,
      isSaveAlert: false,
      alertTitle: i18n.t('scheduleManager_deleteSchedule'),
      alertContentText: i18n.t('alert.deleteScheduleContent', {
        scheduleName,
      }),
      alertConfirmAction: this.deleteSchedule,
    });
  };

  deleteSchedule = () => {
    const pageParams = {
      items: this.state.schedulesItemsPerPage,
      page: this.state.schedulesPageNumber,
      value: this.state.schedulesSearchValue,
      sort: this.state.schedulesSortDirection,
    };
    this.props.deleteSchedule(this.state.scheduleNameId, this.props.customerId, pageParams);
    this.resetScheduleFormFields();
    this.setState({ isAlertDialogOpen: false, hideDetails: true });
  };

  handleScheduleDetailsFormKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (!this.state.schedulesSearchValue) {
        return this.handleSaveSchedule();
      }
    }
  };

  render() {
    const { t, classes, width } = this.props;
    const isLarge = width === 'lg' || width === 'xl';
    const schedulesData = cloneDeep(this.props.schedules);

    return (
      <MainContentContainer className={classes.MainContentContainer}>
        <AlertDialog
          open={this.state.isAlertDialogOpen}
          handleClose={() => this.setState({ isAlertDialogOpen: false })}
          title={this.state.alertTitle}
          contentText={this.state.alertContentText}
          cancelButtonText={t('Global_cancel')}
          confirmButtonText={t('Global_delete')}
          onConfirm={this.state.alertConfirmAction}
        />
        <SnackbarNotification
          variant={this.state.snackbarVariant}
          open={this.state.isSnackbarNotificationOpen}
          message={this.state.snackbarMessage}
          close={() => this.setState({ isSnackbarNotificationOpen: false })}
        />
        <Header />
        <Grid container className={classes.gridContainer} spacing={isLarge ? 6 : 5}>
          <Grid item xs={12} md={6} xl={5}>
            <Paper className={clsx(classes.paper, classes.listWidget)}>
              <Table
                data={schedulesData}
                noDataText={t('doorScheduleManager_dScheduleInfo_noSchedule')}
                handleClick={(value) => this.selectSchedule(value)}
                columns={[{ title: t('common.name'), field: 'name', id: 'name' }]}
                activeRowValue={this.state.scheduleNameId}
                activeRowField={'scheduleNameId'}
                handleSearch={this.handleSearchSchedule}
                sortBy={'name'}
                sortDirection={this.state.schedulesSortDirection}
                handleSort={this.handleSortSchedule}
                searchPlaceholder={t('scheduleManager_searchSchedule')}
                itemsPerPage={this.state.schedulesItemsPerPage}
                changeItemsPerPage={this.changeSchedulesItemsPerPage}
                totalElements={this.props.schedulesTotalElements}
                page={this.state.schedulesPageNumber}
                changePage={this.changeSchedulesPage}
                onKeyPress={this.handleSearchScheduleKeyPress}
                // rows per page select props
                selectData={[5, 10, 20]}
                selectLabel={t('table.showPerPage')}
                selectValue={this.state.schedulesItemsPerPage}
                onSelect={this.changeSchedulesItemsPerPage}
                selectWidth={90}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} xl={7}>
            <Paper className={clsx(classes.paper, classes.detailsWidget)}>
              <SchedulesDetails
                // buttons
                add1ButtonText={t('scheduleManager_addNewSchedule')}
                onDeleteButtonClick={this.openDeleteScheduleAlert}
                onAdd1ButtonClick={this.handleAddSchedule}
                onAdd2ButtonClick={this.handleAddController}
                onSaveButtonClick={this.handleSaveSchedule}
                isDeleteButtonDisabled={!this.state.scheduleNameId || this.state.isNewSchedule}
                // details form
                onKeyPressFormSubmit={this.handleScheduleDetailsFormKeyPress}
                onChange={this.handleChangeFormValues}
                hideDetails={this.state.hideDetails}
                isNewSchedule={this.state.isNewSchedule}
                scheduleNameId={this.state.scheduleNameId}
                name={this.state.name}
                description={this.state.description}
                // form and validations
                isUntouched={this.state.isUntouched}
                setUntouched={(value) => this.setState({ isUntouched: value })}
                // schedule tabs details, weekly and yearly schedule
                weeklyData={this.state.weeklyData}
                changeWeeklyData={(weeklyData) => this.setState({ weeklyData })}
                yearlyData={this.state.yearlyData}
                changeYearlyData={(yearlyData) => this.setState({ yearlyData })}
                checkedExceptions={this.state.checkedExceptions}
                changeCheckedExceptions={(checkedExceptions) => this.setState({ checkedExceptions })}
              />
            </Paper>
          </Grid>
        </Grid>
      </MainContentContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerId: state.auth.customerId,
    //schedules
    schedules: state.schedules.schedules,
    schedulesTotalElements: state.schedules.totalElements,
    createdSchedule: state.schedules.createdSchedule,
    createdSchedule: state.schedules.createdSchedule,
    schedulesIsLoading: state.schedules.isLoading,
    schedulesSuccessMessage: state.schedules.successMessage,
    schedulesErrorMessage: state.schedules.errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getSchedules: (customerId, pageParams) => dispatch(SchedulesActions.getSchedulesRequest(customerId, pageParams)),
  createSchedule: (scheduleInfos, customerId, pageParams) =>
    dispatch(SchedulesActions.createScheduleRequest(scheduleInfos, customerId, pageParams)),
  editSchedule: (scheduleInfos, customerId, pageParams) =>
    dispatch(SchedulesActions.editScheduleRequest(scheduleInfos, customerId, pageParams)),
  deleteSchedule: (scheduleNameId, customerId, pageParams) =>
    dispatch(SchedulesActions.deleteScheduleRequest(scheduleNameId, customerId, pageParams)),
  resetSchedules: () => dispatch(SchedulesActions.resetSchedules()),
});

export default compose(
  withTranslation(),
  withStyles(styles),
  withWidth(),
  connect(mapStateToProps, mapDispatchToProps)
)(Schedules);
